import GaugeWidget from './GaugeWidget'
import TextWidget from './TextWidget'
import ChartWidget from './ChartWidget'
import TableWidget from './TableWidget'
// import NetworkMapWidget from './NetworkMapWidget'
import ValueWidget from './ValueWidget'
import SliderWidget from './SliderWidget'
import TriggerWidget from './TriggerWidget'
import StatusSwitcherWidget from './StatusSwitcherWidget'
// import MapWidget from './MapWidget'
import EnergyWidgetsPage from '../../pages/admin/EnergyWidgetsPage'

import ContractsChartWidget from './ContractsChartWidget'
import TimeBasedReportWidget from './TimeBasedReportWidget'
import ContractsOverviewWidget from './ContractsOverviewWidget'
import ContractsStatusWidget from './ContractsStatusWidget'

const WidgetComponents = {
    GaugeWidget,
    TextWidget,
    ChartWidget,
    TableWidget,
    // NetworkMapWidget,
    ValueWidget,
    SliderWidget,
    TriggerWidget,
    StatusSwitcherWidget,
    // MapWidget,
    EnergyWidgetsPage,
    ContractsChartWidget,
    TimeBasedReportWidget,
    ContractsOverviewWidget,
    ContractsStatusWidget,
}

export default WidgetComponents;